<template>
  <TrainingProgramWorkflowComponent
    :training="training"
    :importing="importing"
    :publishing="publishing"
    @import="importProgram"
    @publish="publish"
  />
  <TrainingProgramSheetComponent
    :training="training"
    :importing="importing"
    :hasBeenImportedOnce="true"
    :active="active"
    :warnings="warnings"
    @refresh="refresh"
  />
  <TrainingModelComponent
    ref="trainingModelComponent"
    :importing="importing"
    :hasBeenImportedOnce="true"
    :active="active"
    @refresh="refresh"
  />
  <TrainingProgramImportModalComponent :open="modalOpen" @import="startImport" @hidden="modalHidden" />
</template>

<script>
import TrainingProgramWorkflowComponent from "@/components/training/program/TrainingProgramWorkflowComponent.vue";
import TrainingProgramSheetComponent from "@/components/training/program/TrainingProgramSheetComponent.vue";
import TrainingModelComponent from "@/components/training/model/TrainingModelComponent.vue";
import { notificationManager } from "@/services/utilities/notification-manager";
import { i18n } from "@/i18n";
import { trainingManager } from "@/services/training/training-manager";
import { messengerMessageManager } from "@/services/messenger-message/messenger-message-manager";
import TrainingProgramImportModalComponent from "@/components/training/program/TrainingProgramImportModalComponent.vue";

export default {
  name: "TrainingProgramComponent",
  components: {
    TrainingProgramImportModalComponent,
    TrainingModelComponent,
    TrainingProgramSheetComponent,
    TrainingProgramWorkflowComponent,
  },
  emits: ["refresh"],
  props: {
    training: {
      type: Object,
      required: true,
    },
    active: {
      type: Boolean,
      required: true,
    },
  },
  computed: {
    hasBeenImportedOnce() {
      return !!this.training.lastProgramImportDate;
    },
  },
  data() {
    return {
      importing: false,
      publishing: false,
      modalOpen: false,
    };
  },
  methods: {
    async publish() {
      const alertResponse = await notificationManager.showAlert(
        "warning",
        i18n.global.t("training.program.alert.program_publish_title"),
        i18n.global.t("training.program.alert.program_publish_sub_title"),
        true,
        true,
      );

      if (!alertResponse.isConfirmed) {
        return;
      }

      this.publishing = true;
      const response = await trainingManager.post(this.$route.params.trainingId, "program/publish-program");
      if (response) {
        this.refresh();
        notificationManager.showNotification(
          response.success ? "success" : "error",
          i18n.global.t(response.success ? "training.publish_program_success" : "signed_error"),
        );
      }
    },

    refresh() {
      this.importing = false;
      this.publishing = false;
      sessionStorage.removeItem("studea-training-" + this.$route.params.trainingId + "-programImportMessageId");
      this.$emit("refresh");
    },

    importProgram(type = null) {
      if (this.hasBeenImportedOnce && !type) {
        this.modalOpen = true;
      } else {
        type = !type ? "crush" : type;
        this.startImport(type);
      }
    },

    async startImport(type = null) {
      if (type === "crush") {
        this.clearData();
      }
      const response = await trainingManager.post(this.$route.params.trainingId, "program/import?action=" + type);
      if (response.error) {
        this.importing = false;
      } else {
        sessionStorage.setItem(
          "studea-training-" + this.$route.params.trainingId + "-programImportMessageId",
          response.messageId,
        );
        this.importing = true;
        messengerMessageManager.processMessage(response);
      }
    },

    clearData() {
      if (this.$refs.trainingModelComponent) {
        this.$refs.trainingModelComponent.clearData();
      }
    },

    modalHidden() {
      this.modalOpen = false;
    },
  },
};
</script>

<style lang="scss" scoped>
.workflow {
  background: $bg-grey;
  border: 1px solid $light-grey;
  border-radius: $radius;
  padding: 20px;
}
</style>
